import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from '@angular/core';
import { FieldTree } from '@angular/forms/signals';

@Component({
  selector: 'app-text-readonly',
  imports: [],
  templateUrl: './text-readonly.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  // Keeps a caller's static `id` attribute off the host element, which would
  // otherwise duplicate the `id` the template below puts on the readonly value.
  host: { '[attr.id]': 'null' },
})
export class TextReadonlyComponent {
  readonly field = input.required<FieldTree<string | null>>();
  readonly id = input('');
  readonly label = input('');
  readonly containerClass = input('');
  readonly textClass = input('');
  readonly placeholder = input('');

  protected readonly state = computed(() => this.field()());

  get text(): string {
    return this.state().value() ?? '';
  }

  get displayText(): string {
    if (!this.text) {
      return this.placeholder() || '';
    }
    // Backend text carries literal escaped breaks, and CRLF is replaced first to avoid a double newline.
    return this.text
      .replace(/\\r\\n/g, '\n')
      .replace(/\\r/g, '\n')
      .replace(/\\n/g, '\n');
  }
}
